import { render, staticRenderFns } from "./topSales.vue?vue&type=template&id=619609a0&"
import script from "./topSales.vue?vue&type=script&lang=ts&"
export * from "./topSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports